/*
*@/components/request/change-close-date
*/
export default {
  changeCloseDate: {
    title: 'Modificación de fecha límite',
    label1: 'Fecha Límite de Respuesta',
    button1: 'Extender plazo',
    script: {
      methods: {
        send: {
          notify: {
            title: 'Extensión plazo de respuesta',
            message: 'Extensión de plazo de respuesta enviada satisfactoriamente.',
          },
          catch: {
            title: 'Solicitud de modificación',
            message: 'Ha ocurrido un error al enviar su solicitud de modificación.',
          },
        },
        confirmSend: {
          label1: '¿Está seguro de cambiar la fecha límite de respuesta?',
          label2: 'Precaución',
          confirmButton: 'OK',
          cancelButton: 'Cancelar',
          notify: {
            title: 'Extensión plazo de respuesta',
            message: 'La extensión del plazo de respuesta se ha cancelado.',
          },
          catch: {
            title: 'Extensión plazo de respuesta',
            message: 'La extensión del plazo de respuesta se ha cancelado',
          },
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/buyer/request_information/components/ChangeCloseDate.js